import type { ResponsiveImageData } from '../data/images'
import { images } from '../data/images'
import { ResponsiveImage } from './ResponsiveImage'

type PageHeroProps = {
  eyebrow?: string
  title: string
  image?: ResponsiveImageData
  objectPosition?: string
  className?: string
}

export function PageHero({ eyebrow, title, image = images['gallery-01'], objectPosition, className }: PageHeroProps) {
  return (
    <section className={`page-hero${className ? ` ${className}` : ''}`}>
      <div className="page-hero__image">
        <ResponsiveImage image={image} alt="" sizes="100vw" objectPosition={objectPosition} priority />
      </div>
      <div className="shell page-hero__content reveal reveal--heading">
        {eyebrow && <span className="eyebrow eyebrow--light">{eyebrow}</span>}
        <h1>{title}</h1>
      </div>
    </section>
  )
}
